import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { config } from './config';

@Injectable({
  providedIn: 'root'
})

export class TiendaService{

  public url = config.url;
  constructor(public http: HttpClient) { }

  postOrden(token, orden): Observable<any>{

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', `Bearer ${token}`);
    
    return this.http.post(this.url+'adquisicion/tienda', orden, { headers: headers });
  }

  getLicencia(token){
    let headers: HttpHeaders = new HttpHeaders()
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', `Bearer ${token}`);
    // Peticion
    return this.http.get(this.url+'adquisicion/tienda', { headers: headers });
  }

  postPago(token, orden): Observable<any>{

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', `Bearer ${token}`);
    
    return this.http.post(this.url+'adquisicion/tienda-pago', orden, { headers: headers });
  }

}